module.exports = __webpack_public_path__ + "img/graf.34f46b25.png";